import { z } from "zod";

import UserRefByIdSchema from "@/areas/directory/schemas/UserRefByIdSchema";

const RemoveSubscriberSchema = z
  .object({
    user: UserRefByIdSchema,
    subscriptions: z.array().max(0, { message: "Roles must be empty." }),
  })
  .strict();

export default RemoveSubscriberSchema;
